<template>
    <div class="modal modal-info fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>Send Message</h4>
                </div>
                <div class="modal-body">
                    <div class="modal-inner">

                        <div class="form">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group form-group-1 mb-3">
                                        <label for="" class="form-label">From</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="from"
                                            readonly
                                        >
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group form-group-1 mb-3">
                                        <label for="" class="form-label">To</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="applicantEmail"
                                            readonly
                                        >
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group form-group-1 mb-3">
                                        <label for="" class="form-label">Subject</label>
                                        <input type="text" class="form-control" v-model="form.subject">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group form-group-1 mb-3">
                                        <label for="" class="form-label">Pre-Configured</label>
                                        <select
                                            class="custom-select"
                                            v-model="preConfigured"
                                            @change="fillInputs"
                                        >
                                            <option
                                                v-for="item in responses"
                                                :key="item.id"
                                                :value="item.id">
                                                {{item.subject}}
                                            </option>
                                            <option value="null">Select Message</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Message</label>
                                        <textarea type="text" class="form-control" v-model="form.message"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btns-wrap mt-4">
                            <button class="btn btn--outline-primary" @click="closeModal">Cancel</button>
                            <button class="btn btn--secondary" @click="sendMessage">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import ApplicantsServices from "../../../app/Modules/Applicants/resources/js/services/ApplicantsServices";

export default {
    name: 'EmailModal',
    props: {
        modalId: {
            type: String,
            required: true,
        },
        applicantEmail: {
            type: String,
            required: true,
        },
        applicantId: Number,
        responses: {
            type: Array,
        }
    },
    data() {
        return {
            preConfigured: null,
            from: 'Info@security.us',
            form: {
                subject: null,
                message: null,
            },
        }
    },
    methods: {
        closeModal() {
            $(`#${this.modalId}`).modal('hide');
        },

        fillInputs() {
            const found = this.responses.find(el => el.id === this.preConfigured)
            if (found) {
                this.form.message = found.message
                this.form.subject = found.subject
            } else {
                this.form.message = null
                this.form.subject = null
            }
        },
        async sendMessage() {
            this.$showLoadingMessage()
            try {
                await ApplicantsServices.sendEmailMessage(this.applicantId, this.form)
                this.$showSuccessMessage('Your message has been sent')
                $(`#${this.modalId}`).modal('hide');
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your Message was not sent')
            }
        },
    },
}

</script>

<style scoped>

</style>
